import script from "./CampaignStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignStatus.vue?vue&type=script&setup=true&lang=js"

import "./CampaignStatus.vue?vue&type=style&index=0&id=6b7d41d2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7d41d2"]])

export default __exports__